import { InvestorEntitiesView } from './InvestorEntitiesView';
import { useInvestors } from '../hooks/useInvestors';

export function InvestorEntitiesTab() {
  const { data: investors, isLoading, error } = useInvestors();

  if (isLoading) {
    return <p className="text-muted-foreground py-6">Loading entities...</p>;
  }

  if (error) {
    return (
      <p className="text-destructive py-6">
        Error loading entities: {error.message}
      </p>
    );
  }

  return <InvestorEntitiesView entities={investors ?? []} />;
}
